import {
    TSpendingLimit,
    useGetBuyerSpendingLimit,
    useGetFormalOffers
} from '@api/lendingAPI/lapiHooks';

import { getLoanDurationInMonths } from '../../../myOffers/MyOffers.helpers';

const useGetIwocapayFormalOffers = () => {
    const { formalOffers, loadingFormalOffers } = useGetFormalOffers();

    return {
        formalOffers: formalOffers.filter(
            (offer) => offer.product_type === 'iwocapay'
        ),
        loadingFormalOffers
    };
};

const DURATION_TO_ID = {
    1: 'THIRTY_DAYS',
    3: 'THREE_MONTHS',
    12: 'TWELVE_MONTHS'
} as const;

export type TSpendingLimitType =
    (typeof DURATION_TO_ID)[keyof typeof DURATION_TO_ID];

export type TSpendingLimits = {
    limits: {
        [k in (typeof DURATION_TO_ID)[keyof typeof DURATION_TO_ID]]:
            | (TSpendingLimit & { interest_rate: number })
            | null;
    };
};
export const useGetSpendingLimits = () => {
    const { buyerSpendingLimit, loadingBuyerSpendingLimit } =
        useGetBuyerSpendingLimit();

    const { formalOffers } = useGetIwocapayFormalOffers();

    if (formalOffers.length === 0 || !buyerSpendingLimit) {
        return {
            activeSpendingLimit: null,
            spendingLimits: null,
            loadingSpendingLimits: loadingBuyerSpendingLimit
        };
    }

    const limits = Object.fromEntries(
        buyerSpendingLimit.spending_limits.map((limit) => {
            const id =
                DURATION_TO_ID[
                    limit.duration_in_months as keyof typeof DURATION_TO_ID
                ];

            const formalOffer = formalOffers.find((offer) => {
                if (!offer.duration) return false;

                return (
                    getLoanDurationInMonths(offer.duration) ===
                    limit.duration_in_months
                );
            });

            if (!formalOffer) return [id, null];

            const spendingLimit = {
                ...limit,
                interest_rate: formalOffer.interest_rates![0].rate!
            };

            return [id, spendingLimit];
        })
    );

    return {
        activeSpendingLimit: buyerSpendingLimit.active_spending_limit,
        spendingLimits: {
            limits: limits
        } as TSpendingLimits,
        loadingSpendingLimits: loadingBuyerSpendingLimit
    };
};
